'use client'

import { useEffect } from 'react'
import { BUSINESS } from '@/lib/constants'
import { TrackedLink } from '@/components/analytics/TrackedLink'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  const phoneTel = BUSINESS.phone.replace(/\D/g, '')

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          background: '#0a0a0a',
          color: '#f5f5f5',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px',
        }}
      >
        <main style={{ maxWidth: 720, width: '100%', textAlign: 'center' }}>
          <div
            style={{
              fontSize: 11,
              letterSpacing: '0.2em',
              color: '#ff4d2e',
              textTransform: 'uppercase',
              marginBottom: 16,
              fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
            }}
          >
            Error
          </div>
          <h1 style={{ fontSize: 'clamp(40px, 5vw, 72px)', margin: '0 0 16px', lineHeight: 1.05 }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: 17, lineHeight: 1.6, color: '#a3a3a3', marginBottom: 32 }}>
            The site hit an unexpected error. Try again, or call us directly. We&apos;re happy to help over the phone.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={reset}
              type="button"
              style={{
                background: '#ff4d2e',
                color: '#0a0a0a',
                border: 'none',
                padding: '14px 28px',
                fontSize: 16,
                fontWeight: 600,
                cursor: 'pointer',
                borderRadius: 4,
              }}
            >
              Try Again
            </button>
            <TrackedLink
              href={`tel:${phoneTel}`}
              location="inline"
              label="global_error_call"
              style={{
                background: 'transparent',
                color: '#f5f5f5',
                border: '1px solid #f5f5f5',
                padding: '14px 28px',
                fontSize: 16,
                fontWeight: 600,
                textDecoration: 'none',
                borderRadius: 4,
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              Call {BUSINESS.phone}
            </TrackedLink>
          </div>
          {error.digest ? (
            <p
              style={{
                fontSize: 11,
                color: '#737373',
                marginTop: 32,
                fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
              }}
            >
              ref: {error.digest}
            </p>
          ) : null}
        </main>
      </body>
    </html>
  )
}
